<app-survey-thanks
  *ngIf="show && smsNavState"
  [smsNavState]="smsNavState"
></app-survey-thanks>
